var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.008 15.506h-4.504L12.5 9.501V.494h9.008V9.5h-4.504l3.003 6.005zm-12.01 0H3.493L.49 9.501V.494H9.5V9.5H4.995l3.002 6.005z",
    fill: "#0078BB",
    fillRule: "evenodd"
  })));
};

export default SvgQuote;